import { useEffect, useState } from "react";
import { Cus_TF } from "../../Components/custom-textfield/Cus_TF.js";
import '../../Style/home/contact.css';
import { Cus_Autocomplete } from "../../Components/custom-combobox/Cus_Autocomplete.js";
import { Cus_TFArea } from "../../Components/custom-textarea/Cus_TFArea.js";
import CustomCheckBox from "../../Components/custom-checkbox/CustomCheckBoxWithCustomWidget.js";
import CustomButton from "../../Components/custom-button/CustomButton.js";
import { t } from "i18next";
import { getTypeCus, getTypeTopic, saveContact } from "../../Services/api-service.js";
import { isNullOrEmpty, ValidatePhone } from "../../Services/service.js";
import { warning } from "../../Components/custom-toast/CustomToast.js";
function ContactSection(){
    const [fullname, setFullname] = useState("");
    const [phonePrefix, setPhonePrefix] = useState("+84");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [email, setEmail] = useState("");
    const [poNumber, setPoNumber] = useState("");
    const [isCustomer, setIsCustomer] = useState("");
    const [topic, setTopic] = useState("");
    const [message, setMessage] = useState("");
    const [confirm, setConfirm] = useState(false);
    const [listTopic, setListTopic] = useState([]);
    const [listCus, setListCus] = useState([]);
    useEffect(()=>{
        getTypeTopic(setListTopic);
        getTypeCus(setListCus);
    },[]);
    const validateBeforeSubmit = () => {
        if(isNullOrEmpty(fullname)) {
            warning(t("nullfullname"));
            return false;
        }
        if(isNullOrEmpty(phonePrefix)) {
            warning(t("nullprefixphone"));
            return false;
        }
        if(isNullOrEmpty(phoneNumber)) {
            warning(t("nullphone"));
            return false;
        }
        if(isNullOrEmpty(email)) {
            warning(t("nullemail"));
            return false;
        }
        if(isNullOrEmpty(poNumber)) {
            warning(t("nullpoNumber"));
            return false;
        }
        if(isNullOrEmpty(isCustomer)) {
            warning(t("nullChoiceCus"));
            return false;
        }
        if(isNullOrEmpty(topic)) {
            warning(t("nullChoiceTopic"));
            return false;
        }
        if(isNullOrEmpty(message)) {
            warning(t("nullnotemessage"));
            return false;
        }
        if(!ValidatePhone(phoneNumber)){
            warning(t("wrongformatphone"));
            return false;
        }
        return true;
    }
    const handleClick = () =>{
        if(validateBeforeSubmit()){
            saveContact({"fullName": fullname, "phonePrefix": phonePrefix, "phoneNumber": phoneNumber, "email": email,
                "typeCus": isCustomer.typeCus, "poNumber": poNumber, "typeTopic": topic.typeTopic, "note": message
            }).finally(()=>{
                setFullname("");
                setEmail("");
                setPhoneNumber("");
                setConfirm(false);
                setMessage("");
                setPoNumber("");
            });
        }
    }
    return (
        <section className="contact">
            <div className="container-card-contact">
                <div className="home-contact-wrapper">
                    <div className="contact-img">
                        <img className="img-contact-style" src="/Assets/Images/contact-image.jpg" alt={t("homecontactimage")} />
                    </div>
                    <div className="contact-form">
                        <div className="title-contact-wrap">
                            <h2 className="home-title-contact">{t("homecontacttitle")}</h2>
                        </div>
                        <p className="home-desc-contact">{t("homecontactdesctitle")}</p>
                        <div className="form-input">
                            <Cus_TF className={"normal-font-textfield"} id={"fullname"} name={"fullname"} placeholder={t("fullname")} value={fullname} setValue={setFullname} />
                        </div>
                        <div className="contact-form-line">
                            <Cus_TF className={"normal-font-textfield"} id={"phonePrefix"} name={"phonePrefix"} placeholder={t("prephone")} value={phonePrefix} setValue={setPhonePrefix} 
                            sx={{
                                width: '25%'
                            }}/>
                            <Cus_TF className={"normal-font-textfield"} id={"phoneNumber"} name={"phoneNumber"} placeholder={t("phonenumber")} value={phoneNumber} setValue={setPhoneNumber} 
                            sx={{
                                width: '75%',
                                paddingLeft: '2%'
                            }}/>
                        </div>
                        <div className="form-input">
                            <Cus_TF className={"normal-font-textfield"} id={"email"} name={"email"} placeholder={"Email"} value={email} setValue={setEmail} />
                        </div>
                        <div className="contact-form-line">
                            <Cus_Autocomplete className={"cus-autocomplete-contact"} option={(cus)=>cus.cusDesc} options={listCus ?? []}
                            sxText={{width: '100%'}} value={isCustomer || null} setValue={setIsCustomer}/>
                            {
                                isCustomer.cusDesc === "Tôi đang quan tâm sản phẩm/ dịch vụ Phú Hưng Life" ? 
                                <></>
                                :
                                <Cus_TF  className={"normal-font-textfield cus-tf-contact"} id={"poNumber"} name={"poNumber"} placeholder={t("ponumber")} value={poNumber} setValue={setPoNumber} 
                                />               
                            }
                        </div>
                        <div className="form-input">
                            <Cus_Autocomplete className={"cus-autocomplete-contact"} option={(topic)=>topic.topicDesc} options={listTopic ?? []}
                            placeholder={t("choosetopic")} sxText={{width: '100%'}} value={topic || null} setValue={setTopic}/>
                        </div>
                        <Cus_TFArea value={message} setValue={setMessage} minRows={2} placeholder={"Lời nhắn cho Phú Hưng Life"}  />
                        <CustomCheckBox childText={<label className="home-desc-contact" style={{marginBottom: "-5px"}}>{t("iagreewith")}<label style={{color: '#c4960c'}}>{t("securityrule")}</label>{t("ofPHL")}</label>}
                            value={confirm} setValue={setConfirm}  />
                        <div className="form-input" style={{display: 'flex', marginTop: "3%"}}>
                            <CustomButton title={t("registernow")} disable={(!confirm)} onClick={handleClick}/>
                            <div style={{width: "max-content", paddingLeft: "3%"}}>
                                <label className="contact-last-title home-desc-contact">{t("cs")}<br/><label style={{color: "#c4960c"}}>{t("csphone")}</label></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>    
    );
}
export default ContactSection;